export enum DataSource {
  Shopify = 1,
  Migration = 2
}